export default __webpack_public_path__ + "daddf030ec596d9ab017e6df49a378c2.wav";